import { useAppDispatch, useAppSelector } from '@/app/hooks';
import { AppState } from '@/app/store';
import { debounce } from 'lodash-es';
import useTranslation from 'next-translate/useTranslation';
import { setMaxPrice, setMinPrice } from './ProductsFilter/productsFilterSlice';
/* eslint-disable no-unused-vars */
export function PriceFilter() {
  const { t } = useTranslation('common');
  const dispatch = useAppDispatch();
  const minPrice = useAppSelector(
    (state: AppState) => state.productFilter.minPrice
  );
  const maxPrice = useAppSelector(
    (state: AppState) => state.productFilter.maxPrice
  );

  function handleSetMaxPrice(val: string) {
    dispatch(setMaxPrice(isNaN(parseInt(val)) ? null : parseInt(val)));
  }
  function handleSetMinPrice(val: string) {
    dispatch(setMinPrice(isNaN(parseInt(val)) ? null : parseInt(val)));
  }

  const debounceSetMinPrice = debounce(handleSetMinPrice, 500);
  const debounceSetMaxPrice = debounce(handleSetMaxPrice, 500);

  return (
    <div
      className='w-full items-center justify-between text-sm text-gray-400 hover:text-gray-500'
      data-testid='filter-price-container'
    >
      <h3 className='my-6 font-medium text-gray-900'>{t('Price')}</h3>
      <div className='flex w-full items-center space-x-4'>
        <input
          id={`filter-price-min`}
          defaultValue={minPrice as number}
          name={`minPrice`}
          type='number'
          className='text-indigo-600 focus:ring-indigo-500 h-8 w-full appearance-none rounded border-gray-300'
          placeholder='Min'
          min={0}
          step={1000}
          onChange={(e) => debounceSetMinPrice(e.target.value)}
          data-testid='product-filter-min-price'
        />
        <input
          id={`filter-price-max`}
          defaultValue={maxPrice as number}
          name={`maxPrice`}
          type='number'
          className='text-indigo-600 focus:ring-indigo-500 h-8 w-full appearance-none rounded border-gray-300'
          placeholder='Max'
          min={0}
          step={1000}
          onChange={(e) => debounceSetMaxPrice(e.target.value)}
          data-testid='product-filter-max-price'
        />
      </div>
    </div>
  );
}
